<script>
  import formFieldMixin from './form-field-mixin.js'

  export default {
    mixins: [
      formFieldMixin
    ],
    props: {
      options: {
        type: [Array, Object],
        default: function _default() {
          return [];
        }
      },
      valueField: {
        type: String,
        default: 'value'
      },
      textField: {
        type: String,
        default: 'text'
      },
      htmlField: {
        type: String,
        default: 'html'
      },
      disabledField: {
        type: String,
        default: 'disabled'
      },
      multiple: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
<template>
  <b-form-group
    :description="description"
    :label="label"
    :label-for="inputName"
    :invalid-feedback="violations"
    :labelClass="labelClasses"
  >
    <b-form-select
      :id="inputName"
      :value="value"
      @change="updateField($event)"
      :state="!isInvalid"
      :disabled="isReadOnly"
      :options="options"
      :valueField="valueField"
      :textField="textField"
      :htmlField="htmlField"
      :disabledField="disabledField"
      :multiple="multiple"
    ></b-form-select>
  </b-form-group>
</template>
